import { render } from "./404.vue?vue&type=template&id=cf5dbb02"
import script from "./404.vue?vue&type=script&lang=ts"
export * from "./404.vue?vue&type=script&lang=ts"
script.render = render

export default script